"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Flex = _interopRequireDefault(require("../../../../../components/shared-components/Flex"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _reactCsv = require("react-csv");

var _icons = require("@ant-design/icons");

var _RmName = _interopRequireDefault(require("../../../../../RmName.json"));

// import { useHistory } from 'react-router';
var todayDate = new Date();
var year = todayDate.getFullYear();
var month = ("0" + (todayDate.getMonth() + 1)).slice(-2);
var day = ("0" + todayDate.getDate()).slice(-2);
var today = "".concat(year, "-").concat(month, "-").concat(day);
var time = "".concat(todayDate.getHours(), ":").concat(todayDate.getMinutes()); // const { Option } = Select;

var CardData = function CardData(_ref) {
  var data = _ref.data;
  var header = [{
    label: "Today Date",
    key: "sendDate"
  }, {
    label: _RmName.default.nameCode,
    key: "RM_code"
  }, {
    label: "RM Name",
    key: "RM_name"
  }, {
    label: "Total Student",
    key: today === data[0].sendDate ? "totalStudent" : "totalRes"
  }, {
    label: "Total Send Worksheet",
    key: "totalSendRes"
  }, {
    label: "Total Not Send Worksheet",
    key: "totalNotRes"
  }];
  var csvRport = {
    filename: "Matn Evening Data " + today + " " + time,
    headers: header,
    data: data
  };
  var avatarSize = 50; // const history = useHistory();
  // const cl = localStorage.getItem("CL");
  // const token = localStorage.getItem("token");
  // const [apiError, setapiError] = useState(null);

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(data),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      tableData = _useState4[0],
      setTableData = _useState4[1]; // useEffect(async () => {
  //     setTableData(data);
  //     setLoading(false);
  // }, [data]);


  (0, _react.useEffect)(function () {
    function fatchData() {
      return _fatchData.apply(this, arguments);
    }

    function _fatchData() {
      _fatchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(data);
                setLoading(false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fatchData.apply(this, arguments);
    }

    fatchData();
  }, [data]);
  return loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "loading"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Math Evening Response",
    style: {
      backgroundColor: '#f5f5f5'
    },
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, tableData.map(function (stu, index) {
    return /*#__PURE__*/_react.default.createElement(_antd.Card, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
      justify: "center"
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "rounded p-2 bg-white shadow-sm mx-auto",
      style: {
        'marginTop': '-2.0rem',
        'maxWidth': "".concat(avatarSize + 16, "px"),
        'maxHeight': '70px'
      }
    }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
      className: "font-size-sm",
      style: {
        backgroundColor: '#04d182'
      },
      size: avatarSize
    }, _utils.default.getNameInitial(stu.RM_name))), /*#__PURE__*/_react.default.createElement("div", {
      className: "ml-md-4 w-100"
    }, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center",
      mobileFlex: false,
      className: "mb-3 text-md-left text-center"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "mb-0"
    }, stu.RM_name)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, _RmName.default.nameCode)), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.RM_code)))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, "Send Date")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.sendDate))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, "Total Res")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.totalRes ? stu.totalRes : "No Data"))))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
      gutter: [8, 8]
    }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
      xxl: 24
    }, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-muted ml-1"
    }, "Total Not Res")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      xxl: 12
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-semibold"
    }, stu.totalNotRes ? stu.totalNotRes : "No Data"))))))));
  })));
};

var _default = CardData;
exports.default = _default;